<template>
	<div class="user-info-page">

		<div class="user-info-sidebar">

			<div class="user-avatar-card">
				<div class="avatar-wrapper">
					<!-- 核心优化：替换硬编码action，使用自定义上传方法 -->
					<el-upload ref="upload" class="avatar-uploader" :http-request="customAvatarUpload" :action="''"
						action :show-file-list="false" :before-upload="beforeAvatarUpload">
						<div class="avatar-circle" v-if="showHeadavatar">
							<img :src="showHeadavatar" class="avatar-img" />
						</div>
						<div class="avatar-circle" v-else>
							<span class="avatar-placeholder">{{ userName[0] || 'L' }}</span>
						</div>
						<span class="main-account-tag">主账号</span>
					</el-upload>
				</div>
				<div class="user-basic-info">
					<h4 class="user-name">{{ userName || '至码云' }}</h4>
					<p class="user-id">ID {{ userId || '0' }}</p>
				</div>

				<div class="security-info">
					<div class="security-item">
						<span class="label">安全手机</span>
						<span class="value">{{ form.phone || '--' }}</span>
						<span class="status bound" v-if="form.phone">已绑定</span>
						<span class="status unbound" v-else>未绑定</span>
					</div>
					<div class="security-item">
						<span class="label">安全邮箱</span>
						<span class="value">{{ form.email || '--' }}</span>
						<span class="status bound" v-if="form.email">已绑定</span>
						<span class="status unbound" v-else>未绑定</span>
					</div>
					<p class="register-time">注册于 {{ registerTime || '2024-04-18 23:22' }}</p>
				</div>
				<div class="realname-info">
					<h5 class="section-title">实名信息</h5>
					<div class="realname-item">
						<span class="label">真实姓名</span>
						<span class="value">{{ realName || '--' }}</span>
						<span class="verify-tag" v-if="realNameStatus">个人认证</span>
						<span class="verify-tag" @click="goAuth" v-else>未认证，去认证</span>
					</div>
					<div class="realname-item">
						<span class="label">证件号码</span>
						<span class="value">{{ idCard || '--' }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 右侧表单面板 -->
		<div class="user-info-form-panel">
			<el-tabs v-model="activeTab" type="card" class="info-tabs">
				<el-tab-pane label="联系信息" name="contact">
					<el-form :model="form" :rules="rules" ref="loginForm" class="info-form">
						<!-- 邮箱地址 -->
						<el-form-item label="邮箱地址" class="form-item">
							<el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
						</el-form-item>

						<!-- 手机号 -->
						<el-form-item label="手机号" class="form-item">
							<el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
						</el-form-item>

						<!-- 提交按钮 -->
						<el-form-item class="form-btn-group">
							<el-button type="primary" @click="change" class="submit-btn">提交</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>

				<el-tab-pane label="详细资料" name="detail">
					<div class="empty-tip">暂无更多资料</div>
				</el-tab-pane>

				<el-tab-pane label="其他信息" name="other">
					<div class="empty-tip">暂无其他信息</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import {
		Upload,
		Tabs,
		TabPane,
		Input,
		Button,
		Form,
		FormItem
	} from "element-ui";
	// 导入项目统一的request实例（路径请根据实际项目调整）
	import request from '@/utils/request.js';

	export default {
		components: {
			ElUpload: Upload,
			ElTabs: Tabs,
			ElTabPane: TabPane,
			ElInput: Input,
			ElButton: Button,
			ElForm: Form,
			ElFormItem: FormItem
		},
		data() {
			const validateEmail = (rule, value, callback) => {
				if (!value) {
					callback();
					return;
				}
				const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
				if (!emailRegex.test(value)) {
					callback(new Error("请输入正确的邮箱地址"));
				} else {
					callback();
				}
			};
			return {
				activeTab: "contact",
				form: {
					headavatar: "",
					phone: "",
					email: "",
					qq: "",
					password: ""
				},
				showHeadavatar: "",
				rules: {
					email: [{
						validator: validateEmail,
						trigger: "blur"
					}]
				},
				userName: "",
				userId: "",
				registerTime: "",
				realName: "",
				idCard: "",
				realNameStatus: ""
			};
		},
		mounted() {
			this.getUserInfo();
		},
		methods: {
			goAuth() {
				this.$router.push('/index')
			},
			async getUserInfo() {
				try {
					const res = await this.$api.getUserInfo.get();
					if (res.code === 200 && res.data) {
						const data = res.data;
						this.userName = data.nickname || data.username || data.name || data.account || '';
						this.userId = data.id || '';
						this.registerTime = data.create_time || data.createtime || '';
						this.form.phone = data.mobile || data.phone || '';
						this.form.email = data.email || '';
						this.form.qq = data.qq || '';
						this.form.headavatar = data.headavatar || data.avatar || '';
						this.showHeadavatar = data.headavatar || data.avatar_url || '';
						if (data.auth_name) {
							this.realName = data.auth_name.length > 2 ?
								data.auth_name[0] + '**' :
								data.auth_name;
						}
						if (data.card_num) {
							this.idCard = data.card_num.length > 8 ?
								data.card_num.slice(0, 2) + '****************' + data.card_num.slice(-2) :
								data.card_num;
						}
						this.realNameStatus = data.status
					}
				} catch (error) {
					console.error('获取用户信息失败:', error);
				}
			},

			// 新增：自定义头像上传方法（核心优化）
			async customAvatarUpload(file) {
				try {
					// 创建FormData（文件上传专用格式）
					const formData = new FormData();
					formData.append('file', file); // 保持name为file，和后端一致

					// 使用项目统一的request实例发起请求
					const res = await request({
						url: '/common/upload', // 仅写接口路径，baseURL自动拼接
						method: 'post',
						data: formData,
						// 覆盖默认Content-Type，适配文件上传
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					});

					// 调用原有成功回调
					this.handleAvatarSuccess(res, file);
					return res;
				} catch (error) {
					// 统一错误提示
					this.$message.error("头像上传失败：" + (error.msg || error.message || "网络异常"));
					// 告知el-upload上传失败
					throw error;
				}
			},

			// 头像上传成功（兼容自定义上传的响应格式）
			handleAvatarSuccess(res, file) {
				console.log("handleAvatarSuccess", res, file);
				// 兼容自定义上传和原生上传的响应格式
				const response = res.data || res;
				if (response.code !== 200) {
					this.$message.error("上传失败: " + (response.msg || "未知错误"));
					return;
				}
				this.form.headavatar = response.data.url;
				this.showHeadavatar = response.data.domain_url;
				this.$message.success("头像上传成功");
			},

			// 上传前校验（保留原有逻辑）
			beforeAvatarUpload(file) {
				const isJPG = file.type === "image/jpeg";
				const isPNG = file.type === "image/png";
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isJPG && !isPNG) {
					this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
					return false;
				}
				if (!isLt2M) {
					this.$message.error("上传头像图片大小不能超过 2MB!");
					return false;
				}
				return true;
			},

			// 修改提交（保留原有逻辑）
			async change() {
				try {
					await this.$refs.loginForm.validate();
				} catch (error) {
					this.$message.warning("请完善表单信息");
					return;
				}

				console.log("修改信息", this.form);
				const res = await this.$api.getUserInfo.editUserInfo(this.form);
				console.log(res);
				if (res.code === 200) {
					this.$message.success("修改成功");
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	// 页面整体布局
	.user-info-page {
		display: flex;
		min-height: 100vh;
		background:
			linear-gradient(135deg, #f8f9fc 0%, #ffffff 50%, #fafbff 100%);
		padding: 30px;
		box-sizing: border-box;
		position: relative;
		overflow: hidden;

		&::before {
			content: '';
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
			z-index: 0;
			background:
				radial-gradient(ellipse 80% 50% at 20% 20%, rgba(94, 96, 206, 0.04) 0%, transparent 50%),
				radial-gradient(ellipse 60% 40% at 80% 30%, rgba(124, 127, 246, 0.04) 0%, transparent 50%);
			animation: backgroundFloat 20s ease-in-out infinite;
		}

		@keyframes backgroundFloat {

			0%,
			100% {
				transform: translate(0, 0) scale(1);
			}

			50% {
				transform: translate(-5px, -5px) scale(1.02);
			}
		}
	}

	.user-info-sidebar {
		width: 320px;
		margin-right: 24px;
		position: relative;
		z-index: 1;
		animation: slideInLeft 0.6s ease-out;

		@keyframes slideInLeft {
			from {
				opacity: 0;
				transform: translateX(-30px);
			}

			to {
				opacity: 1;
				transform: translateX(0);
			}
		}

		.user-avatar-card {
			background: #ffffff;
			border-radius: 20px;
			box-shadow:
				0 10px 40px rgba(94, 96, 206, 0.1),
				0 4px 12px rgba(0, 0, 0, 0.05);
			padding: 30px 24px;
			position: relative;
			overflow: hidden;
			border: 1px solid rgba(94, 96, 206, 0.08);
			transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

			&:hover {
				transform: translateY(-5px);
				box-shadow:
					0 20px 60px rgba(94, 96, 206, 0.15),
					0 8px 20px rgba(0, 0, 0, 0.08);
			}

			.avatar-wrapper {
				text-align: center;
				position: relative;
				margin-bottom: 20px;

				.avatar-uploader {
					display: inline-block;
					position: relative;
				}

				.avatar-circle {
					width: 100px;
					height: 100px;
					border-radius: 50%;
					background:
						linear-gradient(135deg, #e8f3ff 0%, #f0f7ff 100%);
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 0 auto;
					position: relative;
					border: 3px solid #ffffff;
					box-shadow:
						0 8px 24px rgba(94, 96, 206, 0.2),
						0 0 0 4px rgba(94, 96, 206, 0.1);
					transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
					overflow: hidden;

					&::before {
						content: '';
						position: absolute;
						inset: -3px;
						border-radius: 50%;
						background: linear-gradient(135deg, #5e60ce, #7c7ff6, #9381ff);
						z-index: -1;
						animation: borderRotate 3s linear infinite;
					}

					@keyframes borderRotate {
						0% {
							transform: rotate(0deg);
						}

						100% {
							transform: rotate(360deg);
						}
					}

					&:hover {
						transform: scale(1.05);
						box-shadow:
							0 12px 32px rgba(94, 96, 206, 0.3),
							0 0 0 6px rgba(94, 96, 206, 0.15);
					}

					.avatar-img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
						object-fit: cover;
					}

					.avatar-placeholder {
						font-size: 40px;
						background: linear-gradient(135deg, #5e60ce, #7c7ff6);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
						background-clip: text;
						font-weight: 700;
					}
				}

				.main-account-tag {
					display: inline-block;
					background: linear-gradient(135deg, #5e60ce, #7c7ff6);
					color: #fff;
					font-size: 11px;
					padding: 4px 12px;
					border-radius: 12px;
					position: absolute;
					bottom: -8px;
					left: 50%;
					transform: translateX(-50%);
					box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);
					font-weight: 500;
					letter-spacing: 0.5px;
					white-space: nowrap;
				}
			}

			// 用户基本信息
			.user-basic-info {
				text-align: center;
				margin: 25px 0 20px;
				position: relative;
				z-index: 1;

				.user-name {
					font-size: 22px;
					font-weight: 600;
					margin: 0 0 8px;
					background: linear-gradient(135deg, #1a1a2e, #4a4a68);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
				}

				.user-id {
					font-size: 14px;
					color: #8a8aa3;
					margin: 0;
					font-weight: 400;
				}
			}

			.security-info {
				border-top: 1px solid rgba(94, 96, 206, 0.1);
				padding-top: 20px;
				margin-bottom: 20px;
				position: relative;
				z-index: 1;

				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 50%;
					transform: translateX(-50%);
					width: 40px;
					height: 3px;
					background: linear-gradient(90deg, #5e60ce, #7c7ff6);
					border-radius: 2px;
				}

				.security-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 12px;
					font-size: 13px;
					padding: 8px 12px;
					background: rgba(248, 249, 252, 0.5);
					border-radius: 10px;
					transition: all 0.3s ease;

					&:hover {
						background: rgba(94, 96, 206, 0.05);
						transform: translateX(3px);
					}

					.label {
						color: #8a8aa3;
						font-weight: 400;
					}

					.value {
						color: #4a4a68;
						font-weight: 500;
					}

					.status {
						font-size: 11px;
						padding: 3px 8px;
						border-radius: 6px;
						font-weight: 500;

						&.bound {
							color: #2ec4b6;
							background-color: rgba(46, 196, 182, 0.1);
						}

						&.unbound {
							color: #ff6b35;
							background-color: rgba(255, 107, 53, 0.1);
						}
					}
				}

				.register-time {
					font-size: 12px;
					color: #b0b0c0;
					margin: 12px 0 0;
					text-align: center;
				}
			}

			.realname-info {
				border-top: 1px solid rgba(94, 96, 206, 0.1);
				padding-top: 20px;
				position: relative;
				z-index: 1;

				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 50%;
					transform: translateX(-50%);
					width: 40px;
					height: 3px;
					background: linear-gradient(90deg, #5e60ce, #7c7ff6);
					border-radius: 2px;
				}

				.section-title {
					font-size: 15px;
					font-weight: 600;
					margin: 0 0 15px;
					background: linear-gradient(135deg, #1a1a2e, #4a4a68);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
				}

				.realname-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 10px;
					font-size: 13px;
					padding: 8px 12px;
					background: rgba(248, 249, 252, 0.5);
					border-radius: 10px;
					transition: all 0.3s ease;

					&:hover {
						background: rgba(94, 96, 206, 0.05);
						transform: translateX(3px);
					}

					.label {
						color: #8a8aa3;
						font-weight: 400;
					}

					.value {
						color: #4a4a68;
						font-weight: 500;
					}

					.verify-tag {
						font-size: 11px;
						color: #5e60ce;
						background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.1));
						padding: 3px 8px;
						border-radius: 6px;
						font-weight: 500;
					}
				}
			}
		}
	}

	.user-info-form-panel {
		flex: 1;
		background: #ffffff;
		border-radius: 20px;
		box-shadow:
			0 10px 40px rgba(94, 96, 206, 0.1),
			0 4px 12px rgba(0, 0, 0, 0.05);
		padding: 30px;
		position: relative;
		z-index: 1;
		border: 1px solid rgba(94, 96, 206, 0.08);
		animation: slideInRight 0.6s ease-out;

		@keyframes slideInRight {
			from {
				opacity: 0;
				transform: translateX(30px);
			}

			to {
				opacity: 1;
				transform: translateX(0);
			}
		}

		.info-tabs {
			::v-deep .el-tabs__header {
				margin-bottom: 25px;
				border-bottom: 1px solid rgba(94, 96, 206, 0.1);
			}

			::v-deep .el-tabs__nav-wrap::after {
				display: none;
			}

			::v-deep .el-tabs__item {
				font-size: 15px;
				font-weight: 500;
				color: #8a8aa3;
				transition: all 0.3s ease;
				padding: 0 20px;

				&:hover {
					color: #5e60ce;
				}

				&.is-active {
					color: #5e60ce;
					background: linear-gradient(135deg, rgba(94, 96, 206, 0.05), rgba(124, 127, 246, 0.05));
					border-radius: 8px 8px 0 0;
				}
			}

			::v-deep .el-tabs__active-bar {
				background: linear-gradient(90deg, #5e60ce, #7c7ff6);
				height: 3px;
				border-radius: 2px;
			}
		}

		.info-form {
			.form-item {
				margin-bottom: 20px;

				::v-deep .el-form-item__label {
					font-weight: 500;
					color: #4a4a68;
					font-size: 14px;
				}

				::v-deep .el-input__inner {
					border-radius: 10px;
					border: 2px solid #e8eaf2;
					transition: all 0.3s ease;
					height: 44px;

					&:hover {
						border-color: #c5c8d6;
					}

					&:focus {
						border-color: #5e60ce;
						box-shadow: 0 0 0 3px rgba(94, 96, 206, 0.1);
					}
				}
			}

			.form-btn-group {
				margin-top: 30px;

				::v-deep .el-button {
					background: linear-gradient(135deg, #5e60ce, #7c7ff6);
					border: none;
					border-radius: 10px;
					height: 44px;
					padding: 0 40px;
					font-weight: 500;
					box-shadow: 0 4px 15px rgba(94, 96, 206, 0.3);
					transition: all 0.3s ease;

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 8px 25px rgba(94, 96, 206, 0.4);
					}

					&:active {
						transform: translateY(0);
					}
				}
			}
		}

		.empty-tip {
			text-align: center;
			color: #b0b0c0;
			padding: 50px 0;
			font-size: 15px;
		}
	}

	// 响应式设计
	@media (max-width: 1024px) {
		.user-info-page {
			flex-direction: column;
			padding: 20px;
		}

		.user-info-sidebar {
			width: 100%;
			margin-right: 0;
			margin-bottom: 20px;
		}
	}

	@media (max-width: 768px) {
		.user-info-page {
			padding: 15px;
		}

		.user-info-sidebar {
			.user-avatar-card {
				padding: 24px 20px;

				.avatar-wrapper .avatar-circle {
					width: 80px;
					height: 80px;

					.avatar-placeholder {
						font-size: 32px;
					}
				}
			}
		}

		.user-info-form-panel {
			padding: 20px;
		}
	}
</style>